import { z } from 'zod'

export const departureReminderFormSchema = z.object({
  actualDepartureDuration: z.number().min(0),
})

export type DepartureReminderFormValues = z.infer<typeof departureReminderFormSchema>
